import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {RoomPartyMemberOption} from '../../../graphql/groups.datatypes';

export interface DeleteRoomPartyMemberOptionInput {
    id: number
}

interface DeleteRoomPartyMemberOptionData {
    deleteRoomPartyMemberOption: RoomPartyMemberOption,
}

export const DELETE_ROOM_PARTY_MEMBER_OPTION_MUTATION = gql`
  mutation deleteRoomPartyMemberOption($id: Int!){
    deleteRoomPartyMemberOption(id: $id) {
      id
      room_party_member_id
      group_resource_option_id
      unit_count
      unit_cost
    }
  }
`;

export const deleteRoomPartyMemberOption = () => {
    return useMutation<DeleteRoomPartyMemberOptionData, DeleteRoomPartyMemberOptionInput>(
        DELETE_ROOM_PARTY_MEMBER_OPTION_MUTATION,
        {
            update: updateCacheByType('RoomPartyMemberOption'),
        }
    );
};

export default deleteRoomPartyMemberOption;